<template>
  <div class="checkout-silence">
    <div class="checkout-silence__container container-checkout">
      <div class="checkout-silence__video">
        <video
          class="checkout-silence__video-tag"
          width="600"
          poster="@/static/checkout/hero.png"
          ref="quizResultVideo"
          :controls="true"
        >
          <source :src="videoUrl" type="video/mp4" />
        </video>
        <button
          v-if="!isHidePlayBtn"
          class="checkout-silence__video__play btn-reset"
          @click="onPlay"
        >
          <img
            src="@/static/checkout-white/icons/play.svg"
            class="checkout-silence__video__play-icon"
            alt="people"
          />
        </button>
      </div>
      <div class="checkout-silence__wrapper">
        <div class="checkout-silence__title" v-html="title"></div>
        <div class="checkout-silence__subtitle">
          {{ subtitle }}
        </div>
        <div class="checkout-silence__texts">
          <p
            v-for="(item, index) in texts"
            :key="index"
            class="checkout-silence__text"
          >
            {{ item.text }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { videoUrl } from '@/utils/helpers'
export default {
  name: 'CheckoutSilence',
  data() {
    return {
      img_src: '/checkout/hero.png',
      subtitle:
        'Discover the tools and solutions for reaching your mental goal from leading world experts',
      texts: [
        {
          text: 'No matter how long you have had your mental goal or how unique and strange you think it is, you can and you will overcome it with the help of our method.',
        },
        {
          text: 'Ideas like, the only way to treat this problem is to be on medication all your life or that it is something you will just have to cope with forever are NOT TRUE.',
        },
      ],
      isHidePlayBtn: false,
      videoUrl,
    }
  },
  computed: {
    ...mapState(['user']),
    title() {
      return `${
        this.user && this.user.name ? `${this.user.name} , this` : 'This'
      } is your personalized game-changing program. This offer is limited and customized specially for you`
    },
  },
  mounted() {
    this.$refs.quizResultVideo.onpause = () => {
      this.isHidePlayBtn = false
    }
    this.$refs.quizResultVideo.onplay = () => {
      this.isHidePlayBtn = true
    }
  },
  methods: {
    onPlay() {
      this.$refs.quizResultVideo.play()
    },
  },
}
</script>

<style lang="scss">
.checkout-silence {
  padding-bottom: 60px;

  &__video {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    &-tag {
      width: 600px;
      /* height: 467px; */
    }

    &__play {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  &__container {
    display: flex;
    align-items: center;
  }

  &__image {
    max-width: 600px;
  }

  &__wrapper {
    padding-left: 36px;
  }

  &__title {
    font-weight: 400;
    font-size: 48px;
    line-height: 56px;
    padding-bottom: 12px;
    max-width: 691px;

    b {
      font-weight: 800;
    }
  }

  &__subtitle {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    padding-bottom: 12px;
  }

  &__text {
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;

    &:not(:last-child) {
      margin-bottom: 24px;
    }
  }
}
</style>
